
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IValidateField, validateForm } from "@/services/validateForm.ts";

@Component({})
export default class SubscriptionForm extends Vue {
  @Prop({ default: false })
  logo: boolean;

  formFieldArr: IValidateField[] = [
    { name: "email", value: "", rules: "email|min:7" }
  ];
  isValidateErr: boolean = false;
  isSend: boolean = false;
  onShowForm: boolean = true;

  manipulatedForm(route) {
    if (route.path.match('plus500-review-2020-alles-was-sie-brauchen-aktualisiert-2020')) {
      this.onShowForm = false;
    } else {
      this.onShowForm = true;
    }
  }

  mounted() {
    this.manipulatedForm(this.$route);
  }

  @Watch('$route')
  onRouteChange(data: any) {
    this.manipulatedForm(data);
  }

  handleSend(e) {
    this.isSend = true;
    e.target.blur();
    if (this.handleValidate()) {
      this.isSend = false;
      this.$refs.email["value"] = "";
      this.$refs.email["blur"]();
      this.$store.dispatch("app/togglePopupAction", { name: "success" });
    }
  }
  handleValidate() {
    if (!this.isSend) {
      return;
    }
    const emailVal: any = this.$refs.email;
    this.formFieldArr[0].value = emailVal.value;
    const isValid = new validateForm(this.formFieldArr).isValid();
    this.isValidateErr = !isValid;
    return isValid;
  }
}
